//#region src/constants/country.ts
var e = {
	Unknown: "Other",
	"Russian Federation": "Russia",
	"Republic of Lithuania": "Lithuania",
	"Iran, Islamic Republic of": "Iran",
	"Republic of Moldova": "Moldova",
	"Moldova, Republic of": "Moldova",
	"Korea, Republic of": "Republic of Korea",
	"Republic of the Congo": "Congo",
	"DR Congo": "Democratic Republic of the Congo",
	"Congo, The Democratic Republic of the": "Democratic Republic of the Congo"
};
function t(e) {
	return Object.keys(e).reduce((t, n) => {
		let r = e[n];
		return t[r] ? t[r].push(n) : t[r] = [r, n], t;
	}, {});
}
var n = t(e);
//#endregion
export { e as COUNTRY_ALIASES, n as COUNTRY_NAME_TO_VALUE_LOOKUP, t as aggregateCountryNamesToArray };
